import { PlasticsComponent } from './components/landing-page/plastics/plastics.component';
import { LaundryShowcaseComponent } from './components/landing-page/laundry-showcase/laundry-showcase.component';
import { PlasticsShowcaseComponent } from './components/landing-page/plastics-showcase/plastics-showcase.component';
import { ConfectionsComponent } from './components/landing-page/confections/confections.component';
import { LaundryComponent } from './components/landing-page/laundry/laundry.component';
import { ConfectionsShowcaseComponent } from './components/landing-page/confections-showcase/confections-showcase.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { NgxGalleryModule } from 'ngx-gallery-9';

import { AppComponent } from './app.component';
import { HomePageComponent } from './components/landing-page/home-page/home-page.component';
import { LoginComponent } from './components/dashboard/login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { PainelPessoaFisicaComponent } from './components/dashboard/pessoa-fisica/painel-pessoa-fisica/painel-pessoa-fisica.component';
import { CadastroResiduosComponent } from './components/dashboard/pessoa-juridica/cadastro-residuos/cadastro-residuos.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { ProjetosComponent } from './components/landing-page/projetos/projetos.component';
import { PesquisadoresComponent } from './components/landing-page/pesquisadores/pesquisadores.component';
import { EventsComponent } from './components/landing-page/events/events.component';
import { ContactComponent } from './components/landing-page/contact/contact.component';
import { BibliotecaComponent } from './components/landing-page/biblioteca/biblioteca.component';
import { MaterialModule } from './modules/material.module';
import { PainelPessoaJuridicaComponent } from './components/dashboard/pessoa-juridica/painel-pessoa-juridica/painel-pessoa-juridica.component';
import { SolicitantesResiduosComponent } from './components/dashboard/pessoa-juridica/solicitantes-residuos/solicitantes-residuos.component';
import { CadastroComponent } from './components/dashboard/cadastro/cadastro.component';
import { ResetPasswordComponent } from './components/dashboard/reset-password/reset-password.component';
import { NewPasswordComponent } from './components/dashboard/reset-password/new-password/new-password.component';
import { PopUpComponent } from './components/dashboard/pessoa-fisica/painel-pessoa-fisica/pop-up/pop-up.component';
import { LinhasDePesquisaComponent } from './components/landing-page/linhas-de-pesquisa/linhas-de-pesquisa.component';
import { CriaComponent } from './components/landing-page/cria/cria.component';
import { DidaticaComponent } from './components/landing-page/cria/didatica/didatica.component';
import { CriaInformacoesComponent } from './components/landing-page/cria/informacoes/informacoes.component';
import { CriaResultadosComponent } from './components/landing-page/cria/resultados/resultados.component';

@NgModule({
  //Components
  declarations: [
    AppComponent,
    HomePageComponent,
    LoginComponent,
    CadastroComponent,
    PainelPessoaFisicaComponent,
    PainelPessoaJuridicaComponent,
    CadastroResiduosComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    SolicitantesResiduosComponent,
    PopUpComponent,
    NavbarComponent,
    FooterComponent,
    ProjetosComponent,
    PesquisadoresComponent,
    EventsComponent,
    ContactComponent,
    BibliotecaComponent,
    ConfectionsShowcaseComponent,
    LaundryComponent,
    ConfectionsComponent,
    PlasticsShowcaseComponent,
    LaundryShowcaseComponent,
    PlasticsComponent,
    LinhasDePesquisaComponent,
    CriaComponent,
    DidaticaComponent,
    CriaInformacoesComponent,
    CriaResultadosComponent,
  ],

  //Modules
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularFireStorageModule,
    MaterialModule,
    ReactiveFormsModule,
    NgxGalleryModule,
    NgxMaskModule.forRoot(),
  ],

  //Services, Guards
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
